export default __webpack_public_path__ + "static/media/@3x_case_5(780_830).588b4c25.png";